import React from "react";
import { cn } from "src/lib/utils";

const LayoutCard: React.FC<{
  children: React.ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <section
      className={cn(
        `flex w-full flex-col gap-4 rounded-lg px-4 py-6 shadow-[0px_7px_10px_rgba(0,0,0,0.16)] lg:gap-6 ${className}`,
      )}
    >
      {children}
    </section>
  );
};

export default React.memo(LayoutCard);
